import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { songStorageInitialState } from './constants';
import { SongWithMetadata } from './types';

const songStorageSlice = createSlice({
  name: 'songStorage',
  initialState: songStorageInitialState,
  reducers: {
    saveSongsMetadata: (state, action: PayloadAction<SongWithMetadata>) => {
      state.storeSongMetadata.push(action.payload);
    },
    removeExpiredMetadata: (state) => {
      const unexpiredSongsMetadata = state.storeSongMetadata.filter(
        (metadata) => metadata.expiration && metadata.expiration > Date.now(),
      );
      state.storeSongMetadata = unexpiredSongsMetadata;
    },
    clearMetadataStorage: (state) => {
      state.storeSongMetadata = [];
    },
  },
});

export const { saveSongsMetadata, clearMetadataStorage, removeExpiredMetadata } =
  songStorageSlice.actions;

export default songStorageSlice.reducer;
